import { makeStyles } from "e100-react-components";

export const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  text: {
    fontWeight: typography.body1.fontWeight,
  },
  date: {
    fontWeight: typography.body1.fontWeight,
    color: palette.secondary.main,
  },
  warningIcon: {
    display: "block",
    fontSize: typography.h5.fontSize,
    marginLeft: spacing(0.5),
    color: palette.warning.main,
    padding: spacing(0.5),
  },
  textContainer: {
    position: "relative",
  },
  iconContainer: {
    position: "absolute",
    left: spacing(-5),
    top: "10%",
    marginTop: spacing(-1.5),
    zIndex: 1,
  },
  copyIconButtonContainer: {
    marginRight: spacing(),
  },

  item: {
    marginRight: spacing(2),
  },
}));
